document.addEventListener("DOMContentLoaded", function () {
  var playButtons = document.getElementsByClassName("video-box-play-button");

  Array.from(playButtons).forEach(function (playButton) {
    playButton.addEventListener("click", function () {
      var image = this.previousElementSibling;
      var videoContainer = this.nextElementSibling;

      var iframe = videoContainer.querySelector("iframe");

      var player = new Vimeo.Player(iframe);

      image.classList.add("fade-out");
      this.classList.add("fade-out");

      setTimeout(function () {
        image.style.display = "none";
        playButton.style.display = "none";

        setTimeout(function () {
          videoContainer.style.display = "flex";
          videoContainer.classList.add("fade-in");

          player
            .play()
            .catch(function (error) {
              console.error("Error playing the video:", error);
            });
        }, 200);
      }, 100);
    });
  });
});
